<template>
  <div class="show" v-if="showInfo">
    <div class="box">
      <div class="logo" @click="goHome">
        <h1>声学设计与噪声振动控制网</h1>
      </div>
      <div class="certificate">
        <div class="title">
          <h2 class="">企业基本信息</h2>
          <router-link class="back" to="/">返回首页</router-link>
          <router-link class="inquery" :to="$QueryPath+'?inqtye=2'">继续查询</router-link>
        </div>
        <div class="baseinfo">
          <ul>
            <li class="comname">
              <span class="cname">{{ showInfo.qiyename }}</span>
              <span class="info">{{ showInfo.address }}</span>
            </li>
            <li>
              <span class="cname">信用代码</span>
              <span class="info">{{ showInfo.socialcreditcode }}</span>
            </li>
            <li>
              <span class="cname">法定代表人</span>
              <span class="info">{{ showInfo.legalperson }}</span>
            </li>
            <li>
              <span class="cname">注册资金</span>
              <span class="info">{{ showInfo.money }}</span>
            </li>
            <li>
              <span class="cname">企业类型</span>
              <span class="info">{{ showInfo.qiyetype }}</span>
            </li>
            <li class="bottom">
              <span class="cname ywaera">业务范围</span>
              <p class="info ywaera">{{ showInfo.business }}</p>
            </li>
            
          </ul>
        </div>    
      </div>
      <div class="cateinfo">
        <div class="title">
          <h2 class="">企业证书信息</h2>
        </div>
        <ul v-if="showInfo.code">
          <li>
            <span class="cname">企业证书名称</span>
            <span class="info">{{ showInfo.certname }}</span>
          </li>
          <li>
            <span class="cname">证书编号</span>
            <span class="info">{{ showInfo.code }}</span>
          </li>
          <li>
            <span class="cname">申报等级</span>
            <span class="info">{{ showInfo.certlevel }}</span>
          </li>
         
          <li>
            <span class="cname">发证时间</span>
            <span class="info">{{ showInfo.certdate }}</span>
          </li>
          <li>
            <span class="cname">有效时间</span>
            <span class="info">{{ showInfo.valieddate }}</span>
          </li>
          <li>
            <span class="cname">年检记录</span>
            <span class="info">{{ showInfo.nianjian }}</span>
          </li>
          <li>
            <span class="cname">发证机构</span>
            <span class="info">{{ showInfo.regauth }}</span>
          </li>
          <li class="bottom">
            <span class="cname">机关网址</span>
            <span class="info">{{ showInfo.regurl | upperFilter}}</span>
          </li>
        </ul>
        <ul v-else>
          <li class="overdue">
            已过期
          </li>
        </ul>
      </div>
      <div class="copyright">©CopyRight 2023-2024 版权所有</div>
    </div>
  </div>
</template>

<script>
/**
 * 企业证书查询系统模版
 */
import { IP_TEST } from '@/config';
export default {
  name: "ShowQyM",
  data() {
    return {
      IP_TEST
    }
  },
  computed: {
    sealpicsrc() {
      return localStorage.getItem('sealpicsrc');
    }
  },
  props: {
    showInfo: Object
  },
  mounted() {
  },
  methods: {
    goHome() {
      this.$router.push("/");
    }
  }
};
</script>
<style scoped>
.show{
  position: relative;
  width: 100vw;
  min-height: 246.4vw;
  background: #5EB17E;
  box-sizing: border-box;
}
.box {
  position: relative;
  width: 93.6vw;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  overflow: hidden;
}

.box>.logo {
  position: relative;
  margin-top: 3.867vw;
  width: 100%;
   height: 15.466667vw;
  background: url(/static/img/aninq/ios/icon_logobai.png) no-repeat;
  background-size: contain;
  overflow: hidden;
}

.box>.logo>h1 {
  position: absolute;
  left: -1116px;
}
.box>.certificate{
  position: relative;
  margin-top: 4.667vw;
  width: 93.6vw;
  min-height: 120vw;
  border-radius: 1.333vw;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  justify-content: start;
  overflow: hidden;
}
.box>.certificate>.title{
  margin-top: 4.4vw;
  margin-bottom: 3.333vw;
  height: 7.733vw;
  display: flex;
  justify-content: start;
}
.box>.certificate>.title>h2{
  margin-left: 3vw;
  width: 37.333vw;
  height: 7.733vw;
  padding-left: 0.933vw;
  border-radius: 3.867vw;
  line-height: 7.733vw;
  font-size: 3.733vw;

  font-weight: bold;
  color: #38B77C;
  text-align: center;
}
.box>.certificate>.title::before{
  position: absolute;
  content: '';
  width: 42.533vw;
  top:4.4vw;
  left:1.467vw;
  height: 8vw;
  background: url(/static/img/aninq/ios/icon_biaoti1@3x.png) no-repeat;
  background-size: 42.533vw 8vw;
}
.box>.certificate>.title>a.back{
  margin-left: 12.2vw;
  width: 15.733vw;
  height: 7.733vw;
  font-size: 3.733vw;

  font-weight: bold;
  color: #38B77C;
  line-height: 8.533vw;
  text-align: center;
  z-index: 1;
}
.box>.certificate>.title>a.inquery {
  margin-left: 7.733vw;
  width: 15.733vw;
  height: 7.733vw;
  font-size: 3.733vw;

  font-weight: bold;
  color: #333;
  line-height: 8.533vw;
  text-align: center;
  z-index: 1;
}
.box>.certificate>.baseinfo>ul{
  margin: 0 auto;
  width: 90.533vw;
  min-height: 102.8vw;
  border: 0.133vw solid #D1D1D1;
  border-radius: 1.067vw;
}
.box>.certificate>.baseinfo>ul>li{
  width: 90.533vw;
  min-height: 10.533vw;
  border-bottom: 0.133vw solid #F0F0F0;
  display: flex;
  justify-content: start;
}
.box>.certificate>.baseinfo>ul>li>span.cname{
  box-sizing: border-box;
  padding-left: 1.867vw;
  width: 26.267vw;
  min-height: 10.533vw;
  line-height: 10.533vw;
  border-right: 0.133vw solid #F0F0F0;
  font-size: 3.2vw;

  font-weight: 500;
  color: #333333;
}
.box>.certificate>.baseinfo>ul>li>span.info{
  flex: 1;
  padding-left: 3.6vw;
  min-height: 10.533vw;
  line-height: 10.533vw;
  font-size: 3.2vw;

  font-weight: 500;
  color: #333;
}
.box>.certificate>.baseinfo>ul>li.bottom{
  border-bottom: 0;
  min-height: 40vw;
}
.box>.certificate>.baseinfo>ul>li.bottom>span.cname {
  min-height: 40vw;
  line-height: 40vw;
}
.box>.certificate>.baseinfo>ul>li.bottom>span.info {
  box-sizing: border-box;
  height: 40vw;
  line-height: 6.533vw;
  padding: 5.733vw 1.733vw 4vw 3.467vw;
  overflow: hidden;
}
.box>.certificate>.baseinfo>ul>li.comname{
  position: relative;
  width: 90.533vw;
  height: 18.667vw;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: flex-end;
}
.box>.certificate>.baseinfo>ul>li.comname>span.cname{
  margin-top: 3.867vw;
  padding-left:0;
  width: 71.067vw;
  height: 4.267vw;
  font-size: 4.267vw;
  line-height: 4.267vw;

  font-weight: bold;
  color: #333333;
}
.box>.certificate>.baseinfo>ul>li.comname>span.info {
  position: relative;
  padding-left: 0;
  margin-top: -3.4vw;
  width: 67.4vw;
  height: 2.933vw;
  font-size: 2.933vw;
  line-height: 2.933vw;

  font-weight: 500;
  color: #333;
}
.box>.certificate>.baseinfo>ul>li.comname::before{
  position: absolute;
  content: '';
  top: 2.667vw;
  left: 1.6vw;
  width: 13.467vw;
  height: 13.067vw;
  background: url(/static/img/aninq/ios/icon_gognsi@3x.png) no-repeat;
  background-size: 13.467vw 13.067vw;
}
.box>.certificate>.baseinfo>ul>li.comname>span.info::before{
  position: absolute;
  content: '';
  top:0;
  left: -3.667vw;
  width: 2.4vw;
  height: 2.933vw;
  background: url(/static/img/aninq/ios/icon_dizhi@3x.png) no-repeat;
  background-size: 2.4vw 2.933vw;
}
.cateinfo{
  position: relative;
  margin-top: 1.467vw;
  width: 93.6vw;
  height: 92.133vw;
  border-radius: 1.333vw;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  justify-content: start;
  overflow: hidden;
}
.cateinfo>ul{
  margin: 0 auto;
  width: 90.267vw;
  height: 74.933vw;
  border: 0.133vw solid #D1D1D1;
  border-radius: 1.067vw;
}
.box>.cateinfo>.title {
  margin-top: 2.933vw;
  margin-bottom: 3.333vw;
  height: 7.733vw;
  display: flex;
  justify-content: start;
}

.box>.cateinfo>.title>h2 {
  margin-left: 3vw;
  width: 37.333vw;
  height: 7.733vw;
  padding-left: 0.933vw;
  border-radius: 3.867vw;
  line-height: 7.733vw;
  font-size: 3.733vw;

  font-weight: bold;
  color: #38B77C;
  text-align: center;
}
.box>.cateinfo>.title::before {
  position: absolute;
  content: '';
  width: 42.533vw;
  top: 2.933vw;
  left: 1.467vw;
  height: 8vw;
  background: url(/static/img/aninq/ios/icon_biaoti2@3x.png) no-repeat;
  background-size: 42.533vw 8vw;
}

.box>.cateinfo>ul>li {
  width: 90.533vw;
  height: 9.333vw;
  border-bottom: 0.133vw solid #F0F0F0;
  display: flex;
  justify-content: start;
}

.box>.cateinfo>ul>li>span.cname {
  box-sizing: border-box;
  padding-left: 1.867vw;
  width: 26.267vw;
  height: 9.333vw;
  line-height: 9.333vw;
  border-right: 0.133vw solid #F0F0F0;
  font-size: 3.2vw;

  font-weight: 500;
  color: #333333;
}

.box>.cateinfo>ul>li>span.info {
  flex: 1;
  padding-left: 3.6vw;
  height: 9.333vw;
  line-height: 9.333vw;
  font-size: 3.2vw;

  font-weight: 500;
  color: #333;
}
.box>.cateinfo>ul>li.bottom{
  border-bottom: 0;
}
.cateinfo>ul>li.overdue{
  width: 80vw;
  height: 80vw;
  font-size: 3.2vw;

  font-weight: bold;
  color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
}

.copyright{
  position: relative;
  margin-top: 4.133vw;
  height: 2.667vw;
  font-size: 2.667vw;

  font-weight: 500;
  color: #303030;
  line-height: 2.667vw;
}
.box{
  background-color: transparent;
}
.ywaera{
  padding: 1.733vw;
  width: 60vw;
  line-height: 4.533vw;
  font-size: 3.2vw;

  font-weight: 500;
  color: #333;
}
</style>